import type { FC } from 'react'

import { Tooltip } from '@skytech/ui'
import { Td } from '@skytech/ui/Table/Td'
import { Link } from 'react-router-dom'

import { Translation } from '@/components/i18n/Translation'
import { useInjuryReportsContext } from '@/components/injury-reports/index.context'
import type { InjuryReportWithStatusText } from '@/components/injury-reports/types'
import { LocalDate } from '@/components/LocalDate'
import { TrLink } from '@/components/TrLink'
import Highlight from '@/components/util/Highlight'
import { appRoutes } from '@/util/misc'

import { extractCommentFromInjuryReport } from '../helpers'

const InjuryReportListItem: FC<InjuryReportWithStatusText> = ({
  id,
  userName,
  phoneNumber,
  assetDescription,
  injuryDate,
  created,
  statusText,
  customerName,
  latestComment,
}) => {
  const { searchFilter } = useInjuryReportsContext()
  const rowTooltipId = `row-tooltip-${id}`

  const result = extractCommentFromInjuryReport(latestComment)

  return (
    <TrLink data-tooltip-id={rowTooltipId} path={appRoutes.injuryReport.replace(':id', String(id))}>
      <Td>
        <Link to={appRoutes.injuryReport.replace(':id', String(id))}>
          <Highlight pattern={searchFilter} text={String(id)} />
        </Link>
      </Td>

      <Td>
        <div className="user_name">
          <Highlight pattern={searchFilter} text={userName} />
        </div>

        <div className="customer_name">
          <Highlight pattern={searchFilter} text={customerName} />
        </div>

        <div className="code">
          <Highlight pattern={searchFilter} text={phoneNumber} />
        </div>
      </Td>

      <Td>
        <Highlight pattern={searchFilter} text={statusText} />
      </Td>

      <Td>
        <Highlight pattern={searchFilter} text={assetDescription} />
      </Td>

      <Td className="text-right">
        <LocalDate date={injuryDate} />
      </Td>

      <Td className="text-right">
        <LocalDate date={created} />
      </Td>
      {latestComment && (
        <Tooltip
          id={rowTooltipId}
          size="large"
          float
          noArrow
          variant="light"
          place="bottom-start"
          opacity={1}
          // TODO: REMOVE the '!important' when the tooltip is refactored to use tw
          className="!rounded-lg !py-2.5 shadow-md"
        >
          <div className="text-left">
            <div className="mb-1 text-sm text-gray-400">
              <Translation id="Dealer comment " />
            </div>
            {result?.timestamp && (
              <div className="mb-1 text-xs text-gray-400">
                <span>{result?.timestamp}</span>
                {result?.username && (
                  <>
                    <span> - </span>
                    <span>{result?.username}</span>
                  </>
                )}
              </div>
            )}
            <span>{result?.commentText}</span>
          </div>
        </Tooltip>
      )}
    </TrLink>
  )
}

export default InjuryReportListItem
